import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledOrganizationDropdown = styled.div`
  display: none;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    display: block;
    position: fixed;
    padding: 18px;
    width: 335px;
    background: ${theme.token.var('colors.white')};
    z-index: 999;
    top: 80px;
    right: 20px;
    border: 1px solid ${theme.token.var('colors.green.a200')};
    border-radius: ${theme.token.var('borderRadius.big')};
  }

  @media (min-width: ${theme.token('breakpoints.xl')}) {
    right: calc((100% - 1320px) / 2);
  }
`
